import { socket } from '../../../..';
import config from '../../../../config/config';
import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';
import { download } from '../../../sc-utilities/download.utils';
import * as snackbarActions from "../../../sc-utilities/snackbar/store/snackbarActions";
import { CUSTOM } from "../../../sc-utilities/snackbar/store/actionTypes";
import snackbarStore from "../../../../snackbarStore";

// Create CRUD action creator
// const crudActions = restCrudActions({
//     endpointBasePath: 'product-overview',
//     pluginName: 'PRODUCT_OVERVIEW',
//     entityName: 'PRODUCT_OVERVIEW',
//     fetchSuccessMessage: '',
//     loadSuccessMessage: '',

// });

const crudActions = restCrudActions({
    endpointBasePath: 'statistics',
    pluginName: 'STATISTIC',
    entityName: 'STATISTIC',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',

});
// Fetch statistic action creators
export const fetchProductOverviewInit = () => {
    return crudActions.fetchInit();
};
export const fetchProductOverviewStart = () => {
    return crudActions.fetchStart();
};
export const fetchProductOverviewSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchProductOverviewFail = () => {
    return crudActions.fetchFail();
};
export const fetchProductOverview = filter => {
    return async dispatch => {
        await crudActions.fetch(dispatch, filter);
    };
};

export const listProductTypes = (params, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/product-type/list', params, options);
            if (res.data && res.data.succeeded) {
                const productTypes = [];
                for (var productType of res.data.result.data) {
                    productTypes.push({
                        value: `${productType.ProductTypeID}`,
                        label: `${productType.Name}`,
                        key: `${productType.Key}`
                    });
                }
                return productTypes.sort((a, b) => a.label.localeCompare(b.label));
            }
            else {
                if (res && res.canceled) {
                    return [''];
                }
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};

// table view story
export const fetchTableViewsInit = () => {
    return crudActions.fetchInit();
};
export const fetchTableViewStart = () => {
    return crudActions.fetchStart();
};
export const fetchTableViewSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchTableViewFail = () => {
    return crudActions.fetchFail();
};
export const fetchTableViewCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let countRes = await rest.post("table-view/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch grades."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Can not fetch table views."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}
export const fetchTableView = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let listRes = await rest.post("table-view/list", filterData, { cancelToken: options?.tableViewCancel?.token });
            if (listRes && listRes.canceled) {
                return { data: 0, canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                return listRes.data.result.data
            }
            return []

        } catch (error) {
            return []
        }
    }
}

export const loadTableViewInit = () => {
    return crudActions.loadInit();
};
export const loadTableViewStart = () => {
    return crudActions.loadStart();
};
export const loadTableViewSuccess = loadedTableView => {
    return crudActions.loadSuccess(loadedTableView);
};
export const loadTableViewFail = error => {
    return crudActions.loadFail(error);
};
export const loadTableView = (id, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(loadTableViewInit());
        try {
            let listRes = await rest.post("/table-view/load", id, { cancelToken: options.tableViewCancel?.token });
            if (listRes && listRes.canceled) {
                return { data: 0, canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                return listRes.data.result.data;
            }
            dispatch(loadTableViewFail());
            return []

        } catch (error) {
            dispatch(loadTableViewFail());
            return []

        }
    }
};
// Create table view action creators
export const createTableViewInit = () => {
    return crudActions.createInit();
};
export const createTableViewStart = () => {
    return crudActions.createStart();
};
export const createTableViewSuccess = createdTableView => {
    return crudActions.createSuccess(createdTableView);
};
export const createTableViewFail = error => {
    return crudActions.createFail(error);
};

export const createTableView = (params, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createTableViewStart());
        try {
            let res = await rest.post('/table-view/create', params, { cancelToken: options?.tableViewCancel?.token });
            if (res && res.canceled) {
                return { data: 0, canceled: true };
            }
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created table view.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createTableViewFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Can not create table view."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Can not create table view."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createTableViewFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

//Edit table view action creators
export const editTableViewInit = () => {
    return crudActions.editInit();
};
export const editTableViewStart = () => {
    return crudActions.editStart();
};
export const editTableViewSuccess = editedTableView => {
    return crudActions.editSuccess(editedTableView);
};
export const editTableViewFail = error => {
    return crudActions.editFail(error);
};

export const editTableView = (params, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/table-view/save', params, { cancelToken: options?.tableViewCancel?.token });
            if (res && res.canceled) {
                return { data: 0, canceled: true };
            }
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated table view.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Can not edit table view."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}
export const fetchProductOverviewDataCount = (filterData, options = {}) => {
    const rest = getAxiosInstance();

    return async dispatch => {
        try {
            let countRes = await rest.post("/generic-view/count", filterData, { cancelToken: options?.statisticDataCount?.token });
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Can not fetch statistic."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Can not fetch statistic."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}


export const fetchProductOverviewData = (filterData, options = {}) => {
    const rest = getAxiosInstance();

    return async dispatch => {
        try {
            let listRes = await rest.post("/generic-view/list", filterData, { cancelToken: options?.statisticDataList?.token });
            if (listRes && listRes.canceled) {
                return { data: 0, canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                return listRes.data.result.data
            }
            return []

        } catch (error) {
            return []

        }
    }
}



export const setColumnsDraggedData = (data) => {
    return ({
        type: 'HANDLE_DRAGGED_SET',
        columns: data
    });
}
export const setLocationData = (data) => {
    return ({
        type: 'HANDLE_SET_LOCATION',
        location: data
    });
}

export const fetchErasureMethod = (params, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/customer-erasure-method/list', { listAll: true, formatForWEBUI: true, ...params }, { cancelToken: options?.erasuresCancel?.token });
            if (res && res.canceled) {
                return { data: 0, canceled: true };
            }
            if (res.data && res.data.succeeded) {
                const erasureMethods = [];
                for (var erasureMethod of res?.data?.result?.data) {
                    erasureMethods.push(erasureMethod);
                }
                return erasureMethods;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot fetch securaze standards."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            return [];
        }
    };
}


export const exportProductData = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            params['SocketID'] = socket.id.split('#')[1];
            let res = await rest.post('/report/create-collection', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Create collection started.`,
                    options: {
                        variant: 'success'
                    }
                });
                const responseParams = res.data.result.data;
                const redisTopic = responseParams.RedisTopic;
                if (responseParams.AutoDownloadEnabled) {
                    socket.on(redisTopic, async msg => {
                        const { Status, ErasureReportID, RedisTopic } = msg;
                        const { Generated, ToGenerate, Message } = msg;
                        snackbarStore.dispatch(snackbarActions.showCollection({ type: CUSTOM, collection: { Generated, ToGenerate } }));
                        if (Status === 'error') {
                            socket.off(RedisTopic);
                            snackbarStore.dispatch(snackbarActions.hideCollection({ type: CUSTOM, collection: { Generated, ToGenerate } }));
                            return snackActions.snackBar({
                                message: Message || `Error: Create collection failed. Please contact administrator.`,
                                options: {
                                    variant: 'error'
                                }
                            });
                        }

                        if (Status === 'generated') {
                            const objUrl = `${config.backend_domain}:${config.backend_port}/report/download?ReportID=${ErasureReportID}&ActiveCustomerID=${params.ActiveCustomerID}`;
                            socket.off(RedisTopic);
                            snackbarStore.dispatch(snackbarActions.hideCollection({ type: CUSTOM, collection: { Generated, ToGenerate } }));
                            await download(objUrl);
                            snackActions.snackBar({
                                message: `Create collection finished.`,
                                options: {
                                    variant: 'success'
                                }
                            });
                        }

                    });
                }

            } else {
                snackActions.snackBar({
                    message: `Error: Create collection failed. Please contact administrator.`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `Error: Create collection failed. Please contact administrator.`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
}